import clientConfigurationProvider from "../../../../../providers/clientConfigurationProvider";

const getLinkFragment = ({ variantId, recommendationsRequestId }) => {
  const fragments = [
    variantId && `variantId-${variantId}`,
    recommendationsRequestId && `recsreqid-${recommendationsRequestId}`
  ].filter(Boolean);

  return fragments.length ? `#${fragments.join("&")}` : "";
};

const getProductLink = ({
  variantId,
  productId,
  ctaRef,
  recommendationsRequestId
}) => {
  const { siteRootPath } = clientConfigurationProvider();
  const link = `${siteRootPath}prd/${productId}?CTARef=${ctaRef}${getLinkFragment(
    { variantId, recommendationsRequestId }
  )}`;

  return link;
};

export default getProductLink;
